import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Theme } from '../../../../../../theme/theme';

export const ReviewLabel = styled(Box)<{ theme: Theme }>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '24px 12px 24px 24px',
  height: '100%',
  fontWeight: 500,
  fontFamily: theme.fontFamily,
  fontSize: theme.fontSizes.body,
  lineHeight: theme.lineHeights.body,
  color: theme.colors.neutral['500'],
}));
